const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://static.readdy.ai/image/2b8febc409be403949093d91f25c447f/db08953acfe0d979dbe36931a2376ec5.jpeg"
          alt="Modern heating system"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Plumbing &amp; Heating Services
          </h1>
          <p className="text-lg sm:text-xl text-gray-200 mb-8 leading-relaxed">
            Expert installations, repairs &amp; maintenance for your home comfort. Licensed professionals delivering quality service you can trust.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
            <a
              href="#contact"
              className="inline-flex items-center justify-center space-x-2 bg-accent hover:bg-accent-dark text-white px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
            >
              <span>Get Free Quote</span>
              <i className="ri-arrow-right-line text-lg"></i>
            </a>
            <a
              href="tel:+353873719751"
              className="inline-flex items-center justify-center space-x-2 bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary px-8 py-4 rounded-lg font-medium transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>Call Now</span>
            </a>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 text-white">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-accent text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">Licensed &amp; Insured</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-time-line text-accent text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">7am-18pm/6</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-team-line text-accent text-xl"></i>
              <span className="text-sm font-medium whitespace-nowrap">Local Kerry, Cork, Limerik, Dublin Team</span>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Info Bar */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 w-full max-w-6xl px-4">
        <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-2xl p-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-line text-accent text-2xl"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Location</p>
                <p className="text-sm text-gray-900 font-semibold">208 Beechcourt, Killarney, Co. Kerry</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-lg flex-shrink-0">
                <i className="ri-phone-line text-accent text-2xl"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Phone</p>
                <a href="tel:+353873719751" className="text-sm text-gray-900 font-semibold hover:text-accent transition-colors whitespace-nowrap">
                  +353 87 371 9751
                </a>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 flex items-center justify-center bg-accent/10 rounded-lg flex-shrink-0">
                <i className="ri-mail-line text-accent text-2xl"></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 font-medium">Email</p>
                <a href="mailto:smartheatplumb@gmail.com" className="text-sm text-gray-900 font-semibold hover:text-accent transition-colors break-all">
                  smartheatplumb@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;